import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import emitter from 'tiny-emitter/instance';

export default {
  install: app => {
    let token = null;

    const connection = new HubConnectionBuilder()
      .withUrl(`${process.env.VUE_APP_API_URL}base-hub`, {
        accessTokenFactory: () => token
      })
      .configureLogging(LogLevel.Debug)
      .build();
    const baseHub = Object.create({});
    app.config.globalProperties.$hub = baseHub;

    baseHub.connect = t => {
      token = t;
      connection.start()
        .then(() => emitter.emit('connected'))
        .catch(err => console.log(`failed connecting to hub ${err}`));
    };

    baseHub.on = (eventName, callback) => {
      emitter.on(eventName, callback);
    };

    baseHub.off = (eventName, callback) => {
      emitter.off(eventName, callback);
    };

    baseHub.sendMessage = (chatId, text, systemMessage,
      attach, albumPhotoIds, uploadedPhotoIds, parentMessageId, isAnswer, postId) => connection.invoke('SendMessage',
      chatId, text, systemMessage, attach, albumPhotoIds, uploadedPhotoIds, parentMessageId, isAnswer, postId);
    baseHub.pinMessage = (chatId, message) => connection.invoke('PinMessage', chatId, message);
    baseHub.unpinMessage = chatId => connection.invoke('UnpinMessage', chatId);
    baseHub.sendPersonalMessage = (chatId, text, systemMessage,
      attach, albumPhotoIds, uploadedPhotoIds, parentMessageId, isAnswer, postsId) => connection.invoke('SendPersonalMessage',
      chatId, text, systemMessage, attach, albumPhotoIds, uploadedPhotoIds,
      parentMessageId, isAnswer, postsId);
    baseHub.subscribeOnChatAsync = chatId => connection.invoke('SubscribeOnChatAsync', chatId);
    baseHub.deleteMessages = (chatId, Ids) => connection.invoke('DeleteMessages', chatId, Ids);
    baseHub.hideMessages = (chatId, Ids) => connection.invoke('HideMessages', chatId, Ids);
    baseHub.sendMessageToGroupChat = (chatId, text) => connection.invoke('SendMessageToGroupChat', chatId, text);

    baseHub.sendMessageToManipulatorChat = (chatId, text, attach,
      photos, parentMessageId, isAnswer) => connection.invoke('sendMessageToManipulatorChat',
      chatId, text, attach, photos, parentMessageId, isAnswer);

    baseHub.createChat = (name, membersId) => connection.invoke('CreateChat', name, membersId);

    baseHub.updateNotifications = userId => connection.invoke('CreateNotification', userId);

    baseHub.addMembers = (chatId, membersId, withNotify) => connection.invoke('AddMembers', chatId, membersId, withNotify);

    baseHub.addMembersToCall = (chatId, membersId) => connection.invoke('AddToCall', chatId, membersId);

    baseHub.addToGroup = groupName => connection.invoke('AddToGroup', groupName);

    baseHub.removeFromGroup = groupName => connection.invoke('RemoveFromGroup', groupName);

    baseHub.updateFriends = userId => connection.invoke('UpdateFriends', userId);

    baseHub.offerFriendship = userId => connection.invoke('OfferFriendship', userId);

    baseHub.acceptFriendship = userId => connection.invoke('AcceptFriendship', userId);

    baseHub.setBroadcastState = (broadcastId, state) => connection.invoke('SetBroadcastState', broadcastId, state);

    baseHub.addViewer = broadcastId => connection.invoke('AddViewer', broadcastId);

    baseHub.removeViewer = broadcastId => connection.invoke('RemoveViewer', broadcastId);

    baseHub.removeLikeFromBroadcast = broadcastId => connection.invoke('RemoveLikeFromBroadcast', broadcastId);

    baseHub.addLikeToBroadcast = broadcastId => connection.invoke('AddLikeToBroadcast', broadcastId);

    baseHub.removeViewer = broadcastId => connection.invoke('RemoveViewer', broadcastId);

    baseHub.sendMessageToBroadcastChat = (chatId, text) => connection.invoke('SendMessageToBroadcastChat', chatId, text);

    baseHub.call = (chatId, withoutCall) => {
      console.log(`hub${withoutCall},${chatId}`);
      return connection.invoke('Call', chatId, withoutCall);
    };

    baseHub.callEnded = chatId => connection.invoke('CallEnded', chatId);

    connection.on('ReceiveMessage', message => {
      emitter.emit('message-received', message);
    });

    connection.on('PinMessage', message => {
      emitter.emit('pin-message', message);
    });

    connection.on('UnPinMessage', () => {
      emitter.emit('unpin-message');
    });

    connection.on('ReceiveGroupChatMessage', message => {
      emitter.emit('group-chat-message-received', message);
    });
    connection.on('DeleteMessages', messages => {
      emitter.emit('delete-messages', messages);
    });
    connection.on('HideMessages', (messages, userId) => {
      emitter.emit('hide-messages', messages, userId);
    });
    connection.on('ReceiveManipulatorChatMessage', message => {
      emitter.emit('manipulator-chat-message-received', message);
    });

    connection.on('ChatCreated', chat => {
      emitter.emit('chat-created', chat);
    });

    connection.on('NewConversation', conversation => {
      emitter.emit('new-conversation', conversation);
    });

    connection.on('GetChatInvitation', chat => {
      emitter.emit('get-chat-invitation', chat);
    });

    connection.on('MembersAdded', (chatId, newMembers) => {
      emitter.emit('members-added', chatId, newMembers);
    });

    connection.on('UserOffline', userId => {
      emitter.emit('user-offline', userId);
    });

    connection.on('UserOnline', userId => {
      emitter.emit('user-online', userId);
    });

    connection.on('UpdateFriends', () => {
      emitter.emit('update-friends');
    });

    connection.on('ReceiveFriendshipOffer', user => {
      emitter.emit('receive-friendship-offer', user);
    });

    connection.on('ReceiveFriendshipAcceptence', user => {
      emitter.emit('receive-friendship-acceptence', user);
    });

    connection.on('ReceiveCall', (chatId, withoutCall) => {
      console.log('tut', chatId, withoutCall);
      emitter.emit('receive-call', chatId, withoutCall);
    });

    connection.on('AddToCall', chatId => {
      emitter.emit('add-to-call', chatId);
    });

    connection.on('CallEnded', chatId => {
      emitter.emit('call-ended', chatId);
    });

    connection.on('CreateNotification', () => {
      emitter.emit('update-notifications');
    });

    connection.on('ChangeBroadcastState', (broadcastId, state) => {
      emitter.emit('update-broadcast-state', broadcastId, state);
    });

    connection.on('UpdateViewers', (broadcastId, viewers) => {
      emitter.emit('update-viewers', broadcastId, viewers);
    });

    connection.on('ChangeBroadcastState', (broadcastId, state) => {
      emitter.emit('change-broadcast-state', broadcastId, state);
    });
    connection.on('ReceiveBroadcastMessage', message => {
      emitter.emit('receive-broadcast-message', message);
    });

    connection.on('UpdateBroadcastLikes', message => {
      emitter.emit('update-broadcast-likes', message);
    });
  }
};
